import { Select } from 'antd';
import TextTypography from 'src/app/components/shared/Typography/Text';

interface IProps {
  value: string[];
  onChange: (val: string[]) => void;
  options: { label: string; value: string }[]; // The options will now come from the parent
  placeholder: string;
  label: string;
  clasNames?: string;
  isLabel?: boolean;
  mode?: "multiple" | "tags";  // Only accept 'multiple' or 'tags'
  style?: Record<string, string>;
}

const SelectInput = ({
                       value,
                       onChange,
                       options,
                       placeholder,
                       label,
                       clasNames = '',
                       isLabel = true,
                       mode = "multiple",  // Default is 'multiple'
                       style = {},
                     }: IProps) => {

  return (
    <div className="w-full">
      {isLabel && (
        <label>
          <TextTypography fontSize={14}>{label}</TextTypography>
        </label>
      )}

      <Select
        className={`h-[36px] w-full ${clasNames}`}
        mode={mode}
        allowClear
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        options={options}
        showSearch
        optionFilterProp="label"
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toString()
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toString().toLowerCase())
        }
      />
    </div>
  );
};

export default SelectInput;
